import React, { useState } from "react";
import DataTable from "react-data-table-component-with-filter";
import {
  customDataTableStyles,
  defaultPageLimit,
  defaultRowsPerPageOptions,
} from "../Helper/Constants";
import GetSvgIcon, { GetSvgCalendar } from "../../images/svglist";
import { Tooltip } from "react-tooltip";
import { Badge, OverlayTrigger, Popover } from "react-bootstrap";
import {
  AD_HOC_CH_ORDER,
  LINEHAUL_ADMIN_USER_TYPE,
  LINEHAUL_CUSTOMER_USER_TYPE_LIST,
  LINEHAUL_STAFF_USER_TYPE,
  DLVEVENT,
  CHRECEIVEQR,
  ORD_STS,
  CHACFMRATE,
  ORDER_TYPE,
  ORDER_STATUS_PENDING,
  CHCXLORD,
} from "../../ConfigConstants/ConfigConstants";
import { getUserInfo } from "../AuthUtils/AuthUtils";
import {
  getKiplForm,
  getOrderStatusBadgeClass,
  permissionCheck,
} from "../Helper/CommonMethods";
import { CallApiGet } from "../Helper/serviceApi";

const CharteredOrdersList = ({
  handelRepeatBooking,
  handlePlanBtnClick,
  charteredList,
  openCharteredDetails,
  openConfirmAlert,
  downloadDO,
  downloadReceiveQR,
  handleCxlShipment,
  getDeliveryEventLog,
  openCHOrderBooking,
  orderCancellationLog,
}) => {
  const [confirmButtom, setConfirmButtom] = useState("Confirm");
  const userType = getUserInfo("userType");
  const PlanBtn = ({ row }) => {
    const isStaff = [
      LINEHAUL_ADMIN_USER_TYPE,
      LINEHAUL_STAFF_USER_TYPE,
    ].includes(getUserInfo("userType"));

    return (
      <>
        {isStaff && (
          <>
            <div
              data-tooltip-id={"plan" + row.orderId}
              onClick={() => handlePlanBtnClick(row)}
              className="theme-violet-txt"
            >
              {GetSvgCalendar("Calender")}
            </div>
            <Tooltip
              id={"plan" + row.orderId}
              content={"Chartered Planning"}
              place="left"
            />
          </>
        )}
      </>
    );
  };

  const ConfirmWgtBtn = ({ row }) => {
    const isWgtToConfirm =
      LINEHAUL_CUSTOMER_USER_TYPE_LIST.includes(getUserInfo("userType")) &&
      !row.isConfirm &&
      !!row.serviceValue &&
      row.serviceValue > 0;
    return (
      <>
        {isWgtToConfirm && (
          <>
            <div
              data-tooltip-id={"plan" + row.orderId}
              onClick={() => openConfirmAlert(row)}
              className="ms-2 theme-violet-txt"
            >
              {GetSvgIcon("IconDiscountFill")}
            </div>
            <Tooltip
              id={"plan" + row.orderId}
              content={"Confirm Weight"}
              place="left"
            />
          </>
        )}
      </>
    );
  };

  const ActionBtn = ({ row }) => {
    let retBtn = <></>;
    if (row?.orderType === AD_HOC_CH_ORDER) {
      retBtn = <PlanBtn row={row} />;
    } else {
      retBtn = <ConfirmWgtBtn row={row} />;
    }
    return retBtn;
  };

  const QrCodeBtn = ({ data }) => {
    const qrArr = JSON.parse(data?.qrCode);
    return (
      <>
        {!ORDER_STATUS_PENDING.includes(data?.statusId) &&
          qrArr &&
          qrArr.length > 0 &&
          qrArr.map((e, i) => (
            <div
              key={i}
              className="action-item-button"
              onClick={() =>
                downloadReceiveQR(data?.orderId, e.receive_qr_code, e.stop_seq)
              }
            >
              {GetSvgIcon("Print")}{" "}
              {e.stop_seq === 99 ? "Destination QR" : `Stop-${e.stop_seq} QR`}
            </div>
          ))}
      </>
    );
  };

  const ActionPopover = ({ data }) => {
    const handleCxl = (row) => {
      document.getElementById(`row-action-button-${row?.orderId}`).click();
      handleCxlShipment(row);
    };
    return (
      <>
        {LINEHAUL_CUSTOMER_USER_TYPE_LIST.includes(userType) &&
          data?.orderType === ORDER_TYPE.CHA && (
            <div
              className="action-item-button"
              onClick={() => handelRepeatBooking(data.orderId, data.customerId)}
            >
              {GetSvgIcon("IconDiscount")} Repeat Booking
            </div>
          )}
        {data?.statusId !== 77 && (
          // !ORDER_STATUS_PENDING.includes(data?.statusId) &&
          <>
            <div
              className="action-item-button"
              onClick={() => downloadDO(data)}
            >
              {GetSvgIcon("Print")} Print DO
            </div>
            {permissionCheck(CHRECEIVEQR, "allowedRead") && (
              <QrCodeBtn data={data} />
            )}
          </>
        )}
        {permissionCheck(CHCXLORD, "allowedWrite") &&
        LINEHAUL_CUSTOMER_USER_TYPE_LIST.includes(getUserInfo("userType"))
          ? ![77, 79].includes(data?.statusId) &&
            !data?.tripStart && (
              <div
                className="action-item-button"
                onClick={() => handleCxl(data)}
              >
                {GetSvgIcon("IconDiscount")} Cancel{" "}
              </div>
            )
          : ![77, 79].includes(data?.statusId) && (
              <div
                className="action-item-button"
                onClick={() => handleCxl(data)}
              >
                {GetSvgIcon("IconDiscount")} Cancel{" "}
              </div>
            )}

        {permissionCheck(CHCXLORD, "allowedRead") && data?.statusId === 77 && (
          <div
            className="action-item-button"
            onClick={() => orderCancellationLog(data.orderId)}
            data-bs-toggle="modal"
            data-bs-target="#order_cancellation-log-modal"
          >
            {GetSvgIcon("BiBoxArrowInLeft")} Cancellation Log{" "}
          </div>
        )}

        {permissionCheck(DLVEVENT, "allowedRead") && (
          <div
            className="action-item-button"
            onClick={() => getDeliveryEventLog(data?.orderId)}
            data-bs-toggle="modal"
            data-bs-target="#delivery-event-log-modal"
          >
            {GetSvgIcon("IconDiscount")} Delivery Log
          </div>
        )}
        {[ORD_STS.AWAIT_QTY_CFM, ORD_STS.AWAIT_RATE_CFM].includes(
          data?.statusId
        ) &&
          permissionCheck(CHACFMRATE, "allowedWrite") && (
            <div
              className="action-item-button"
              onClick={() => openCHOrderBooking("order", data)}
            >
              {GetSvgIcon("IconDiscount")}
              {data?.statusId === ORD_STS.AWAIT_RATE_CFM
                ? "Confirm quotation price"
                : "Confirm Quantity"}
            </div>
          )}
        {data?.statusId === 75 && data.inv_status === 178 && (
          <>
            <div
              className="action-item-button"
              onClick={() => makePayment(data)}
            >
              {GetSvgIcon("CashStack")} Make Payment
            </div>
          </>
        )}
      </>
    );
  };

  const makePayment = async (row) => {
    let payGatewayDtls = await CallApiGet(
      "get-pay-gateway?shipmentId=" + row.orderId
    );
    if (payGatewayDtls.respCode === 200) {
      document.getElementById("paymentForm").innerHTML = getKiplForm(
        payGatewayDtls.respData.paymentGateway,
        row?.orderId
      );
      document.getElementById("onlinepayment").submit();
    }
  };

  const getFullAddress = (row, type) => {
    const isOrigin = type === "origin";
    const orgAddr = isOrigin ? row?.orgAddr : row?.destAddr;
    const orgCity = isOrigin ? row?.orgCity : row?.destCity;
    const orgState = isOrigin ? row?.orgState : row?.destState;
    const orgPostcode = isOrigin ? row?.orgPostcode : row?.destPostcode;

    return `Address: ${orgAddr}\ncity: ${orgCity}\nstate: ${orgState}\nPostCode: ${orgPostcode}`;
  };

  const columns = [
    // {
    //   name: "Account Code",
    //   selector: (row) => row?.acctCode,
    //   sortable: true,
    //   filterable: true,
    // },
    {
      name: "Name",
      selector: (row) => `${row?.custName} (${row?.acctCode})`,
      sortable: true,
      filterable: true,
    },
    {
      name: "Company Name",
      selector: (row) =>
        row?.businessName === "null" ? "" : row?.businessName,
      sortable: true,
      filterable: true,
    },
    {
      name: "Order No",
      selector: (row) => row?.orderNo,
      cell: (row) => (
        <>
          <div
            onClick={() => openCharteredDetails("order", row)}
            className="modal-links fw-bold"
          >
            {row.orderNo}
          </div>
        </>
      ),
      sortable: true,
      filterable: true,
    },
    {
      name: "Do Number",
      selector: (row) => row?.doNumber,
      sortable: true,
      filterable: true,
    },
    {
      name: "Origin",
      selector: (row) => row?.origin,
      sortable: true,
      filterable: true,
      cell: (row) => (
        <>
          <pre className="box-text">
            <span className="d-inline-block">
              {getFullAddress(row, "origin")}
            </span>
          </pre>
        </>
      ),
      width: "150px",
    },
    {
      name: "Destination",
      selector: (row) => row?.destination,
      sortable: true,
      filterable: true,
      cell: (row) => (
        <>
          <pre className="box-text">
            <span className="d-inline-block">
              {getFullAddress(row, "destination")}
            </span>
          </pre>
        </>
      ),
      width: "150px",
    },
    {
      name: "Booked on",
      selector: (row) => row?.bookedOn,
      sortable: true,
      filterable: true,
    },
    {
      name: "Pickup Date",
      selector: (row) => row?.shipmentDate,
      sortable: true,
      filterable: true,
      cell: (row) => <span className="p-0">{row?.shipmentDate}</span>,
    },
    {
      name: "Delivery Date",
      selector: (row) => row?.estDelivery,
      sortable: true,
      filterable: true,
      cell: (row) => <span className="p-0">{row?.estDelivery}</span>,
    },
    {
      name: "Order Type",
      selector: (row) =>
        row?.orderType === AD_HOC_CH_ORDER ? "On-Demand" : "Planned",
      sortable: true,
      filterable: true,
    },
    {
      name: "Status",
      selector: (row) => row?.statusText,
      sortable: true,
      filterable: true,
      cell: (row) => (
        <span className="p-1">
          <Badge
            className={`text-wrap ${getOrderStatusBadgeClass({
              status: row?.statusId,
            })}`}
          >
            {row.inv_status === 710 ? row.inv_status_txt : row?.statusText}
          </Badge>
        </span>
      ),
    },

    // {
    //   name: "",
    //   cell: (row) => <ActionBtn row={row} />,
    //   width: "40px",
    // },
    {
      name: "",
      width: "15px",
      cell: (row) => (
        <>
          {/* <ActionBtn row={row} /> */}
          <OverlayTrigger
            key={row?.orderId}
            trigger="click"
            placement="left"
            rootClose={true}
            overlay={
              <Popover id="popover-basic">
                <Popover.Body>
                  <ActionPopover data={row} />
                </Popover.Body>
              </Popover>
            }
          >
            <span
              className="row-action-button"
              id={`row-action-button-${row?.orderId}`}
            >
              {GetSvgIcon("Trippleverticaldot")}
            </span>
          </OverlayTrigger>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="col-md-12 customized-data-table position-relative customize-tbl-design">
        <DataTable
          columns={columns}
          data={charteredList}
          pagination
          striped
          highlightOnHover
          paginationRowsPerPageOptions={defaultRowsPerPageOptions}
          paginationPerPage={defaultPageLimit}
          customStyles={customDataTableStyles}
        />
      </div>
    </>
  );
};

export default CharteredOrdersList;
